const loadValueTeasers = () => {
  const teasers = document.querySelectorAll(".teaser.value");
  console.log("Value Teaser JS Loaded");

  if (teasers.length > 0) {
    console.log({ teasers });

    teasers.forEach((teaser) => {
      const cmpTeaser = teaser.querySelector(".cmp-teaser");
      const content = teaser.querySelector(".cmp-teaser__content");
      const description = teaser.querySelector(".cmp-teaser__description");
      const title = teaser.querySelector(".cmp-teaser__title");

      if (title && description && cmpTeaser && content) {
        description.remove();
        title.remove();

        const newDiv = document.createElement("div");
        newDiv.classList.add("cmp-teaser__content-container");

        newDiv.appendChild(title);
        newDiv.appendChild(description);

        content.appendChild(newDiv);
      }
    });
  }

  // Call the icon animations init if available
  if (window.initValueTeaserIconAnimations) {
    window.initValueTeaserIconAnimations();
  }
};

const waitForTeasers = () => {
  const observer = new MutationObserver((mutationsList, observer) => {
    const teasers = document.querySelectorAll(".teaser.value");
    if (teasers.length > 0) {
      loadValueTeasers();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
    console.log("Stopped observing due to timeout.");
  }, 10000);
};

if (document.readyState !== "loading") {
  console.log("loading on document ready");
  loadValueTeasers();
  waitForTeasers();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    loadValueTeasers();
    waitForTeasers();
  });
}
